<template>
  <div>
    <nav>
      <ul class="nav nav-tabs scroll" role="tablist">
        <li role="presentation">
          <a href="#details" class="active" aria-controls="details" role="tab" data-toggle="tab">Detalles</a>
        </li>
        <li role="presentation">
          <a href="#financials" aria-controls="financials" role="tab" data-toggle="tab">Finanzas</a>
        </li>
        <li role="presentation">
          <a href="#documents" aria-controls="financials" role="tab" data-toggle="tab">Documentos</a>
        </li>
        <li role="presentation">
          <a href="#buying" aria-controls="financials" role="tab" data-toggle="tab">Proceso de Compra</a>
        </li>
        <li role="presentation">
          <a href="#market" aria-controls="financials" role="tab" data-toggle="tab">Mercado</a>
        </li>
        <li role="presentation">
          <a href="#orderbook" aria-controls="financials" role="tab" data-toggle="tab">Órdenes</a>
        </li>
      </ul>
    </nav>
    <div class="tab-content">
      <div role="tabpanel" class="tab-pane active" id="details">
        <Details :property="property" />
      </div>
      <div role="tabpanel" class="tab-pane" id="financials">
        <Financials :property="property" />
      </div>
      <div role="tabpanel" class="tab-pane" id="documents">
        <Documents :property="property" />
      </div>
      <div role="tabpanel" class="tab-pane" id="buying">
        <Buying :property="property" />
      </div>
      <div role="tabpanel" class="tab-pane" id="market">
        <Market :property="property" />
      </div>
      <div role="tabpanel" class="tab-pane" id="orderbook">
        <OrderBook :property="property"/>
      </div>
    </div>
  </div>
</template>

<script>
import Details from '@/components/Tabs/Details';
import Financials from '@/components/Tabs/Financials' 
import Documents from '@/components/Tabs/Documents'
import Buying from "@/components/Tabs/Buying"
import Market from '@/components/Tabs/Market'
import OrderBook from '@/components/Tabs/OrderBook'


export default {
  name: 'Tabs',
  props: {
    property: {
      type: Object,
      required: true
    }
  },
  components: {
    Details,
    Financials,
    Buying,
    Market,
    OrderBook,
    Documents
},
created () {
    console.log('ESto paso en la INDEX ', this.property.attributes)
  }
}
</script>

<style lang="scss" scoped>
.scroll {
  white-space: nowrap; /* [1] */
  overflow-x: auto; /* [2] */
  -webkit-overflow-scrolling: touch; /* [3] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [4] */ }

.scroll::-webkit-scrollbar {
  display: none; }
.nav {
    display: flex;
    flex-wrap:nowrap;
    padding-left: 0;
    margin-bottom: 0;
    list-style: none;
}
  ul.nav-tabs {
  border: 0;
  li {
    height: 40px;
    a {
      border-bottom: 4px #D9D9D9 solid;
      
      &.active {
        color: #120427;
        border-color: #9AEEC5;
      }
      color: #828282;
      padding-top: 4px;
      padding-bottom: 8px;
      padding-left: 16px;
      padding-right: 16px;
      font-size: 18px;
      line-height: 15px;
      font-family: 'Montserrat', sans-serif;
    }
  }
}

.tab-content {
  padding: 36px 16px;
}
</style>